/**
 * whether the agent options of the customers/bob filters are ready to show
 * @param agentsOptions - agent options built so far
 * @param isAdmin - whether the user is an agency admin, the only role that fetches its agencies' agents
 * @param agenciesOptions - agencies whose agents were requested, as `{ id }`; a loaded admin always has their own agency here, so an empty list means the agency data is still loading
 * @param agentsByAgency - agents fetched so far, keyed by agency id
 */
export function areAgencyAgentsLoaded({
  agentsOptions,
  isAdmin,
  agenciesOptions,
  agentsByAgency
}) {
  if (agentsOptions.length > 0) return true;
  if (!isAdmin) return true;
  // an agency with no agents is stored as an empty list, so a missing key means it's still loading
  return (
    agenciesOptions.length > 0 &&
    agenciesOptions.every(agency =>
      Object.prototype.hasOwnProperty.call(agentsByAgency, agency.id)
    )
  );
}
